<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M18.4584 19.1076C17.4303 21.7469 12.662 21.8173 12.662 21.8173C8.22158 21.8679 7.07303 19.6261 7.07303 19.6261C10.6802 21.4948 15.0455 21.296 18.4584 19.1076ZM2.22117 9.81451C2.18407 9.87286 1.6782 10.7348 3.53478 11.654C3.53478 11.654 3.84785 11.7949 3.9238 12.3079L3.92947 12.3348C4.0627 12.835 6.03249 15.1021 12.612 14.9816C12.612 14.9816 12.6728 14.9837 12.7849 14.9845L12.9434 14.9847C14.429 14.9768 20.4744 14.7061 22.1245 10.8808C22.1245 10.8808 23.1304 20.0994 12.0599 20.2493L11.9171 20.2491C10.842 20.2342 4.04172 19.8947 3.36806 13.7062C3.36806 13.7062 3.21615 11.981 2.42329 11.2078C2.42329 11.2078 1.62301 10.5466 2.22322 9.81136L2.22117 9.81451ZM22.4746 3.01713C22.8878 3.08819 23.264 3.29391 23.5417 3.60063L24.6217 4.59059C25.0533 5.1217 25.0385 5.58777 24.9496 5.89849C24.6865 6.80174 23.475 7.34188 23.0822 7.49543L20.9093 10.3497C21.0149 10.9982 20.8982 11.9159 19.7385 12.6024L19.7098 12.6229C19.5016 12.7693 18.1884 13.6594 16.6448 13.9392L20.3739 9.83846L22.6339 6.89206L22.7377 6.85593C23.0785 6.7349 24.0882 6.2634 24.2512 5.69978C24.3022 5.46928 24.2328 5.22912 24.0659 5.05847L23.0211 4.09922C22.8536 3.90542 22.6226 3.77397 22.3672 3.72708C21.6855 3.62231 21.2761 4.52555 21.0538 5.30415L21.0204 5.41796L9.85177 14.1975C7.16751 14.0891 4.87042 12.5193 4.64627 11.6847C4.56453 11.3274 4.29095 11.0413 3.93121 10.9368C2.39735 10.5629 2.89011 9.81498 2.89011 9.81498C3.74848 8.63237 5.48536 9.05101 5.7291 9.11685L5.75777 9.12489C10.2667 6.27605 14.9683 7.17026 16.7856 7.68873L20.3646 5.00428C20.6351 4.12451 21.2464 2.83648 22.4746 3.01713Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgMPANewsFeed',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>